var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m95.073 31.841c-2.198-4.863-5.234-9.25-9.023-13.038-8.332-8.332-19.411-12.922-31.196-12.922-22.674 0-41.401 17.194-43.844 39.227l-3.154-3.154c-1.561-1.563-4.094-1.562-5.656 0-1.563 1.562-1.563 4.095 0 5.657l10.14 10.141c.75.75 1.768 1.172 2.828 1.172s2.078-.421 2.828-1.171l10.141-10.141c1.563-1.563 1.563-4.095 0-5.657-1.561-1.562-4.096-1.562-5.656 0l-3.443 3.443c2.27-17.749 17.461-31.516 35.817-31.516 9.647 0 18.717 3.757 25.539 10.579 3.104 3.104 5.591 6.696 7.39 10.676 2.116 4.682 3.188 9.683 3.188 14.864 0 19.916-16.202 36.119-36.117 36.119-9.646 0-18.714-3.755-25.535-10.574-1.563-1.562-4.095-1.561-5.657.001s-1.562 4.095.001 5.657c8.333 8.329 19.41 12.916 31.191 12.916 24.326 0 44.117-19.792 44.117-44.119 0-6.326-1.312-12.435-3.899-18.16z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64.999 70.501c-1.023 0-2.048-.391-2.828-1.171l-10.26-10.26c-.75-.75-1.172-1.768-1.172-2.829v-26.241c0-2.209 1.791-4 4-4s4 1.791 4 4v24.584l9.088 9.088c1.563 1.563 1.563 4.095 0 5.657-.78.781-1.805 1.172-2.828 1.172z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.00471ec4ac19934be4fcdad32090fafd.svg";
export { ForwardRef as ReactComponent };